// Feature flags - toggle UI features via environment variables
// Set REACT_APP_FEATURE_CREW_MANAGEMENT_UI=true in .env to enable new crew management UI
const flags = {
  CREW_MANAGEMENT_UI: process.env.REACT_APP_FEATURE_CREW_MANAGEMENT_UI === 'true',
};

export default flags;
